import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// NEW: wrap the app with AuthProvider
import { AuthProvider } from './auth/AuthContext';

import { installBugLog } from './utils/bugLog';
import { installSessionExpiryInterceptor } from './utils/fetchInterceptor';

// Both patch a global and must run BEFORE React renders so nothing escapes them:
//   • installBugLog        — buffers console output + window errors from first
//                            paint onward, so "Report a bug" has the context.
//   • installSessionExpiry — patches window.fetch to catch the SWA-edge HTML 401
//                            that means the auth session died, instead of
//                            letting it surface as a raw HTML dump in an alert().
installBugLog();
installSessionExpiryInterceptor();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();